import { Job } from "@core/domains/jobs";
import { notificationApi } from "@core/ports/notifications";
import { z } from "@core/zod";

export const busNotificationApi = notificationApi({
  "bus:job:status-update": z.object(
    { job: Job.schema },
    { job: "The job whose status changed" },
  ),
});

export const NotificationSubscriptionSchema = z.object(
  { channel: z.string(), notificationToken: z.unknown() },
  {
    channel: "The name of the notification channel to subscribe to",
    notificationToken: "The token that authorizes the subscription",
  },
);
